import { render, staticRenderFns } from "./job_form_success.html?vue&type=template&id=4b85d048&scoped=true&"
import script from "./job_form_success.vue?vue&type=script&scoped=true&lang=js&"
export * from "./job_form_success.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./job_form_success.scss?vue&type=style&index=0&id=4b85d048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85d048",
  null
  
)

export default component.exports